import {
  DetailMemberEntity,
  MemberUpdateEntity,
} from "../../../OM/OM006/entity/Entity";
import {
  BranchPaginationEntity,
  MemberEntity,
  RolePaginationEntity,
} from "../entity/Entity";
import { OM003API } from "./ServiceImpl";

const Service = (dataSource: OM003API) => {
  const createNewMember = async (data: MemberEntity): Promise<any> => {
    try {
      return await dataSource.createNewMember(data);
    } catch (error) {
      throw error;
    }
  };

  const getPresignAvatarUpload = async (params: any): Promise<any> => {
    try {
      return await dataSource.getPresignAvatarUpload(params);
    } catch (error) {
      throw error;
    }
  };

  const uploadAvatar = async (
    data: any,
    url: string,
    type: string
  ): Promise<any> => {
    try {
      return await dataSource.uploadAvatar(data, url, type);
    } catch (error) {
      throw error;
    }
  };

  const getBranchList = async (
    params: any
  ): Promise<BranchPaginationEntity> => {
    return await dataSource.getBranchList(params);
  };

  const getRoleList = async (params: any): Promise<RolePaginationEntity> => {
    return await dataSource.getRoleList(params);
  };

  const getCertificateType = async (): Promise<any> =>
    await dataSource.getCertificateType();

  const updateMemberAvatar = async (params: any): Promise<any> => {
    try {
      return await dataSource.updateMemberAvatar(params);
    } catch (error) {
      throw error;
    }
  };
  const deleteMember = async (params: any): Promise<any> => {
    try {
      return await dataSource.deleteMember(params);
    } catch (error) {
      throw error;
    }
  };
  const getDetailMember = async (
    params: any
  ): Promise<DetailMemberEntity | null> => {
    const detailMember = await dataSource.getDetailMember(params);
    if (detailMember)
      return { ...detailMember, s3ImageUrl: detailMember?.avatar };
    return detailMember;
  };

  const getS3MemberImage = async (params: any): Promise<any> => {
    try {
      return await dataSource.getS3MemberImage(params);
    } catch (error) {
      throw error;
    }
  };
  const updateMember = async (data: MemberUpdateEntity): Promise<any> => {
    try {
      return await dataSource.updateMember(data);
    } catch (error) {
      throw error;
    }
  };
  const getGroup = async (): Promise<any> => {
    try {
      return await dataSource.getGroup();
    } catch (error) {
      throw error;
    }
  };
  return {
    createNewMember,
    getBranchList,
    getRoleList,
    getCertificateType,
    getPresignAvatarUpload,
    uploadAvatar,
    updateMemberAvatar,
    getDetailMember,
    getS3MemberImage,
    updateMember,
    deleteMember,
    getGroup,
  };
};

export default Service;
